// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/TestTiemposText-Medium-BF66457a508489a.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "TiemposText";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

.footer {
  display: flex;
  justify-content: center; /* Centers content horizontally */
  align-items: center; /* Centers content vertically */
  background-color: #eee2df;
  color: rgb(0, 0, 0);
  height: 80px;
}

.text {
  font-family: "TiemposText", sans-serif;
  font-size: 1rem;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Footer.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,iCAAiC;EAC1D,mBAAmB,EAAE,+BAA+B;EACpD,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["@font-face {\n  font-family: \"TiemposText\";\n  src: url(\"../assets/TestTiemposText-Medium-BF66457a508489a.otf\")\n    format(\"opentype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.footer {\n  display: flex;\n  justify-content: center; /* Centers content horizontally */\n  align-items: center; /* Centers content vertically */\n  background-color: #eee2df;\n  color: rgb(0, 0, 0);\n  height: 80px;\n}\n\n.text {\n  font-family: \"TiemposText\", sans-serif;\n  font-size: 1rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
